import { LoginComponent } from "../components/LoginComponent";
import { HeadTitle } from "../components/share/HeadTitle";
import { Footer } from "../components/share/Footer";
import { NavbarIndexComponent } from "../components/share/NavbarIndexComponent";




export function LoginContainer() {
    const titleName = "เข้าสู่ระบบ";
    return (
        <div className="page-container bg-landing">
            <NavbarIndexComponent />
            <HeadTitle title={titleName} />
            <LoginComponent />
            <Footer />
        </div>
    );
}